import { useState, useEffect } from 'react';
export function useGraphDimensions(containerRef, defaultWidth = 800, defaultHeight = 600) {
    const [dimensions, setDimensions] = useState({
        width: defaultWidth,
        height: defaultHeight,
    });
    useEffect(() => {
        const updateDimensions = () => {
            if (containerRef.current) {
                const { width, height } = containerRef.current.getBoundingClientRect();
                setDimensions({ width, height });
            }
        };
        updateDimensions();
        window.addEventListener('resize', updateDimensions);
        return () => window.removeEventListener('resize', updateDimensions);
    }, [containerRef]);
    return dimensions;
}
